import { Box } from "@mui/material";
import { Notification } from "components/UI";
import { useEffect } from "react";
import { useCentralStore } from "stores";
import { KidForm } from "../components";

export function AddKid() {
  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);

  useEffect(() => {
    setHeaderTitle("Kid Registration Form");

    return () => setHeaderTitle("");
  }, []);

  return (
    <Box sx={{ px: { xs: 2, md: 6 }, pt: 6, pb: 4 }}>
      <Notification />
      <KidForm isEditMode={false} />
    </Box>
  );
}
